export const SEO = {
  title: "Apel Team",
  url: "https://flext.dev",
  description:
    "Aswan Practical Engineering Lab is a student activity in Aswan Faculty of Engineering.",
  siteName: "Flext.dev",
  github: "https://github.com/FelixTellmann/flext",
  avatar: "https://avatars.githubusercontent.com/u/22034038",
  author: "Apel web team",
  twitter: {
    handle: "@Tellmann",
    site: "@FelixTellmann",
    cardType: "summary_large_image",
  },
  openGraph: {
    type: "website",
    locale: "en_IE",
    url: "https://flext.dev",
    site_name: "Flext.dev",
    title: "Felix Tellmann",
    description:
      "Lets make things better with quality code - Learn Web Development / API's / Automations / Serverless / Architecture / and more.",
    images: [
      {
        url: "https://flext.dev/images/sharing-image.jpg",
        alt: "Felix Tellmann - Full-stack Engineer - Next.js, Typescript, Tailwindcss, Shopify",
        width: 1200,
        height: 630,
      },
    ],
  },
};

export const BLOG_SEO = {
  title: "Felix Tellmann - Blog",
  description:
    "Learn Web Development - TypeScript / React / APIs / Automations / Serverless / Architecture / and more. - Lets make things better with quality code",
  openGraph: {
    title: "Felix Tellmann - Blog",
    description:
      "Learn Web Development - TypeScript / React / APIs / Automations / Serverless / Architecture / and more. - Lets make things better with quality code",
  },
};
